import { render, staticRenderFns } from "./reportRevenue.vue?vue&type=template&id=b108b35e&"
import script from "./reportRevenue.vue?vue&type=script&lang=js&"
export * from "./reportRevenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports